import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import BeneficiaryUpdateComponent from './component'

export const BeneficiaryUpdate = combine({
  hooks: [
    withContext(
      'adminMemberService',
      ServicesContext,
      ({ adminMemberService }) => adminMemberService
    ),

    withContext(
      'preRegistrationService',
      ServicesContext,
      ({ preRegistrationService }) => preRegistrationService
    ),

    withContext(
      'adminBeneficiariesService',
      ServicesContext,
      ({ adminBeneficiariesService }) => adminBeneficiariesService
    ),

    withCallbacks(
      {
        getBeneficiaryInfoById:
          ({ adminMemberService }) =>
          async (beneficiaryId) => {
            return await adminMemberService.getMemberById(beneficiaryId)
          },
        getLinkForBeneConfirmSignUp:
          ({ preRegistrationService }) =>
          async (beneficiaryPreRegistrationId) => {
            return await preRegistrationService.getLinkForBeneConfirmSignUp(
              beneficiaryPreRegistrationId
            )
          },
        onSubmit:
          ({ adminMemberService }, { history }) =>
          async (beneficiariesDTO) => {
            await adminMemberService.updateMember(beneficiariesDTO)
            toaster.info('Beneficiary has been successfully updated')
            history.push(admin.beneficiaries.update.view(beneficiariesDTO.id))
          },
      },
      []
    ),
  ],
  transformProps: ({
    match,
    getBeneficiaryInfoById,
    getLinkForBeneConfirmSignUp,
    onSubmit,
  }) => {
    return {
      beneficiaryId: Number(match.params.beneficiaryId),
      getBeneficiaryInfoById,
      getLinkForBeneConfirmSignUp,
      onSubmit,
    }
  },
})(BeneficiaryUpdateComponent)
